import React, { useCallback, useState } from "react";
import { InfoTooltip, Label14Medium } from "components";
import type { EmissionTarget } from "api/emission-targets";
import {
  AddTargetButton,
  AddTargetModal,
  TargetsSettingsTable,
  emissionTargetToEditTargetData,
  type EditTargetData,
} from "./components";

export const TargetsPage = () => {
  const [isAddTargetModalOpen, setIsAddTargetModalOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<EditTargetData | null>(null);

  const toggleAddTargetModal = () => {
    setIsAddTargetModalOpen(!isAddTargetModalOpen);
  };

  const handleCloseAddTargetModal = () => {
    setIsAddTargetModalOpen(false);
    setEditTarget(null);
  };

  const handleEditTarget = useCallback((target: EmissionTarget) => {
    setEditTarget(emissionTargetToEditTargetData(target));
    setIsAddTargetModalOpen(true);
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, margin: "12px 24px" }}>
      <div style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "space-between" }}>
        <Label14Medium color="text.secondary">
          Define emissions reduction targets by organizational level.
        </Label14Medium>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <AddTargetButton onToggleAddTargetModal={toggleAddTargetModal} />
          <InfoTooltip
            width="20px"
            height="20px"
            tooltip="Targets are defined independently at each level and are not aggregated."
          />
        </div>
      </div>
      <TargetsSettingsTable onEditTarget={handleEditTarget} />
      {isAddTargetModalOpen && (
        <AddTargetModal
          isAddTargetModalOpen={isAddTargetModalOpen}
          onAddTargetModalClose={handleCloseAddTargetModal}
          editTarget={editTarget}
        />
      )}
    </div>
  );
};
